import React, { FC } from 'react';
import { WishlistFilled } from 'jl-design-system/components/icons/WishlistFilled';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';
import { UnderlinedButton } from 'jl-design-system/components/button/Button';
import styles from './add-to-wishlist-notification.scss';

interface AddToWishListNotificationProps {
  signInUrl: string;
  registerUrl: string;
  onClose: () => void;
}

export const AddToWishListNotification: FC<AddToWishListNotificationProps> = ({
  signInUrl,
  registerUrl,
  onClose,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.triangle} />
      <div className={styles.popup} data-testid="wishlist-added-popup">
        <div className={styles.header}>
          <span className={styles.message}>
            <WishlistFilled className={styles.wishlistIcon} size="medium" />{' '}
            Added to your{' '}
            <UnderlinedButton
              aria-label="wish list"
              className={styles.link}
              data-testid="wishlist-link"
              href={'/wish-list/guest'}
              size="small"
              tag="a"
              labelText="wish list"
            />
          </span>
          <button
            aria-label="Close popup"
            className={styles.closeButton}
            data-testid="close-popup-button"
            onClick={onClose}
          >
            <CloseOutlined className={styles.closeIcon} size="medium" />
          </button>
        </div>
        <div className={styles.footer}>
          <p className={styles.footerText}>
            We&apos;ll keep your wish list for 60 days.{' '}
            <a href={signInUrl} className={styles.link}>
              Sign in
            </a>{' '}
            or{' '}
            <a href={registerUrl} className={styles.link}>
              register
            </a>{' '}
            to save your items across your devices.
          </p>
        </div>
      </div>
    </div>
  );
};
